import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import {Observable} from 'rxjs';

@Injectable()
export class MyHttpService {

  constructor(protected http: Http) {}

  headers = new Headers({
    'Content-Type': 'application/json',
    'Accept' : 'application/json'
  });

  postJson(url: string, data: any, access_token: string): Observable<Response> {
    //console.log("url: " + url);
    //console.log("data: " + data);
    url += "?access_token=" + access_token;
    return this.http.post(
      url,
      //JSON.stringify(data),
      data,
      {headers: this.headers}
    )
  }

  loginUserLoopBack(url: string): Observable<Response> {
      url += "/login"

      /*const headers = new Headers()
          .set('cache-control', 'no-cache')
          .set('content-type', 'application/json')
          //.set('postman-token', 'b408a67d-5f78-54fc-2fb7-00f6e9cefbd1');*/

      const body = {
          email: 'manuel.sanchez.aponte@gmail.com',
          password: 'catanTan0762LN',
          ttl: '346896000'
      }
      console.log("Login: Url: " + url);
      console.log("Login: Body: " + body);
      console.log("Login: headers: " + this.headers);
      return this.http
                 .post(url, body, { headers: this.headers });

    }

  patchJson(url: string, data: any, access_token: string): Observable<Response> {
    //console.log("url: " + url);
    //console.log("data: " + data);
    url += "?access_token=" + access_token;
    return this.http.patch(
      url,
      //JSON.stringify(data),
      data,
      {headers: this.headers}
    )
  }

  delete(url:string, access_token: string): Observable<Response> {
    url += "?access_token=" + access_token;
    console.log("url: " + url);
    let headersDetele = new Headers({

      'Accept' : 'application/json'
    });
    //console.log("data: " + data);
    return this.http.delete(url, {headers: headersDetele});
      /*delete(
      url,
      //JSON.stringify(data),
      data, */


  }


  escapeHtml(unsafe) {
    if(unsafe)
      return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
                .replace(/"/g, "'").replace(/'/g, "&#039;");
    return "";
 }
}



// WEBPACK FOOTER //
// ./src/app/services/MyHttpService.ts